import { Component, OnInit } from '@angular/core';
import { Setting } from '@model/setting';
import { SendService } from '@service/send/send.service';
import { FilterService } from '@service/filter/filter.service';
import { SettingService } from '@service/setting/setting.service';
import { FilterData } from './send-filter/send-filter.component';

@Component({
  selector: 'app-send',
  templateUrl: './send.component.html',
  styleUrls: ['./send.component.scss']
})
export class SendComponent implements OnInit {

  activeView: 'compose' | 'sent' | 'waiting' | 'trash' | 'detail' = 'sent';
  activeSubTab: 'mail' | 'sms' = 'mail';
  previousView: string = 'sent';
  selectedMessage: any = null;
  setting: Setting;
  sends: any[] = [];
  loading: boolean = false;
  counts: { envoye: number; attente: number; corbeille: number } = { envoye: 0, attente: 0, corbeille: 0 };

  constructor(
    private sendService: SendService,
    private filterService: FilterService,
    private settingService: SettingService
  ) {}

  ngOnInit(): void {
    this.settingService.getSingle().subscribe((res: any) => this.setting = res, () => {});
    this.loadMessages('MAIL', 'ENVOYE');
    this.loadCounts();
  }

  // Navigation
  onNavigate(view: 'compose' | 'sent' | 'waiting' | 'trash'): void {
    this.activeView = view;
    this.selectedMessage = null;
    switch (view) {
      case 'sent':
        this.activeSubTab = 'mail';
        this.loadMessages('MAIL', 'ENVOYE');
        break;
      case 'waiting':
        this.loadMessages('TOUT', 'ATTENTE');
        break;
      case 'trash':
        this.loadMessages('TOUT', 'CORBEILLE');
        break;
    }
  }

  onSubTabChange(tab: 'mail' | 'sms'): void {
    this.activeSubTab = tab;
    this.loadMessages(tab === 'mail' ? 'MAIL' : 'SMS', 'ENVOYE');
  }

  // Chargement
  loadMessages(type: string, etat: string): void {
    this.loading = true;
    this.sendService.getList(type, etat).subscribe(
      res => { this.sends = res; this.loading = false; },
      () => this.loading = false
    );
  }

  loadCounts(): void {
    this.sendService.getCounts().subscribe(
      res => this.counts = res,
      () => {}
    );
  }

  // Filtrage
  onFilter(filter: FilterData): void {
    this.loading = true;
    this.activeSubTab = filter.type === 'SMS' ? 'sms' : 'mail';
    this.filterService.search(filter, 'mailSms', null).subscribe(
      res => { this.sends = res; this.loading = false; },
      () => this.loading = false
    );
  }

  // Détail
  onShowDetail(message: any): void {
    this.previousView = this.activeView;
    this.selectedMessage = message;
    this.selectedMessage.destinataire = [...message.destinataire];
    this.activeView = 'detail';
  }

  onBackToList(): void {
    this.activeView = this.previousView as any || 'sent';
    this.selectedMessage = null;
  }

  // Actions messages
  onMessageSent(): void {
    this.activeView = 'sent';
    this.activeSubTab = 'mail';
    this.loadMessages('MAIL', 'ENVOYE');
    this.loadCounts();
  }

  onMoveToTrash(item: any): void {
    this.sendService.corbeille({ uuid: item.uuid, type: 'CORBEILLE' }).subscribe(res => {
      this.removeFromList(item);
      this.loadCounts();
    });
  }

  onRestore(item: any): void {
    this.sendService.corbeille({ uuid: item.uuid, type: 'RESTAURER' }).subscribe(res => {
      this.removeFromList(item);
      this.loadCounts();
    });
  }

  onResend(item: any): void {
    this.sendService.sendBack(item).subscribe(res => {
      this.removeFromList(item);
      this.loadCounts();
    });
  }

  onDeletePermanent(item: any): void {
    this.sendService.getDelete(item.uuid).subscribe(res => {
      this.removeFromList(item);
      this.loadCounts();
    });
  }

  private removeFromList(item: any): void {
    const index = this.sends.findIndex(x => x.uuid === item.uuid);
    if (index !== -1) {
      this.sends.splice(index, 1);
    }
  }
}
